// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c792e5f1","513":"93e9c798","703":"4e604c50"}[chunkId] + ".chunk.js";
};